import type { BrandContentFormat, CreatorDeal } from '../api/payment/brand-deal.api';
import { validateContentFormat } from './brand-content-format';

// Nội dung theo từng lời mời, đề nghị chỉnh, bài có sẵn (spec 2026-10-12 §5). Câu khớp BrandDealContentConst phía payment.

export const EDIT_NOTE_MIN_LENGTH = 10;
export const EDIT_NOTE_MAX_LENGTH = 500;
export const EDIT_NOTE_INVALID_MESSAGE = 'Ghi chú đề nghị chỉnh từ 10 đến 500 ký tự.';
export const DIRECT_EDIT_FAIRNESS_NOTE =
  'Nhắn tin xin chỉnh không tính lượt. Chỉ nút Đề nghị chỉnh mới tính lượt, và người đặt không bắt buộc phải sửa theo tin nhắn.';
export const DIRECT_EDIT_USED_UP_NOTE = 'Bạn đã dùng hết lượt đề nghị chỉnh, giờ chỉ còn đồng ý hoặc từ chối lời mời.';
export const EXISTING_POST_PICKED_NOTE = 'Người đặt chọn một bài có sẵn của bạn.';
export const EXISTING_POST_PENDING_NOTE = 'Bài có sẵn không còn dùng được, bạn chờ người đặt chọn lại bài nhé.';
export const EXISTING_POST_RESELECT_NOTE = 'Bài có sẵn không còn dùng được, bạn cần chọn lại bài hoặc chuyển sang nội dung mới.';
export const EXISTING_POST_FORM_NOTE =
  'Bài có sẵn giữ nguyên ngày đăng và không được đẩy lên đầu bảng tin. Nhãn hợp tác gắn vào bài vĩnh viễn để đúng quy định công khai quảng cáo. Bài cũ không có link theo dõi nên không đếm được lượt bấm.';
export const EXISTING_POST_REQUIRED_MESSAGE = 'Hãy chọn một bài có sẵn của creator.';
export const NO_CANDIDATES_MESSAGE = 'Creator chưa có bài công khai nào hợp định dạng của chiến dịch.';
/** Admin: nội dung đơn đã đổi so với bản lúc mời (bản mới nhất > 1), không qua admin duyệt lại (R19, R20). */
export const EDITED_AFTER_REVIEW_LABEL = 'Đã chỉnh sau duyệt';

export const validateEditNote = (note: string): string | null => {
  const length = (note ?? '').trim().length;
  return length < EDIT_NOTE_MIN_LENGTH || length > EDIT_NOTE_MAX_LENGTH ? EDIT_NOTE_INVALID_MESSAGE : null;
};

export const directEditCounterLabel = (count: number, max: number): string => `Đã đề nghị chỉnh ${count}/${max}`;

/** Bản 1 là nội dung lúc mời nên không cần nhãn. */
export const contentVersionLabel = (version?: number | null): string | null =>
  version && version > 1 ? `Nội dung bản ${version}` : null;

export const existingPostLink = (postId: string): string => `/share/post/${postId}`;

export const isContentConflict = (err: unknown): boolean =>
  (err as { response?: { status?: number } })?.response?.status === 409;

export const acceptConfirmText = (deal: Pick<CreatorDeal, 'existingPostId' | 'campaign'>): string =>
  deal.existingPostId
    ? `Bài có sẵn của bạn sẽ được gắn nhãn hợp tác vĩnh viễn và phải giữ công khai ${deal.campaign.holdDays} ngày, trong thời gian này không xoá được bài. Ẩn bài trước hạn sẽ không nhận tiền.`
    : `Bài sẽ đăng công khai và phải giữ ${deal.campaign.holdDays} ngày. Xoá hoặc ẩn trước hạn sẽ không nhận tiền.`;

export const excerpt = (text: string, max = 140): string => {
  const t = (text ?? '').trim();
  return t.length <= max ? t : `${t.slice(0, max).trimEnd()}…`;
};

/** Cùng hai lớp kiểm với máy chủ (BrandDealContentRules.ValidateNew): chữ và media chung, rồi định dạng. */
export const validateNewDealContent = (
  format: BrandContentFormat | string | null | undefined,
  caption: string,
  images: number,
  videos: number
): string | null => {
  const text = caption ?? '';
  if (!text.trim()) return 'Bạn chưa nhập nội dung.';
  if (text.length > 2000) return 'Nội dung tối đa 2000 ký tự.';
  if (images <= 0 && videos <= 0 && format !== 'Article') return 'Cần ít nhất 1 ảnh hoặc video.';
  if (images > 10) return 'Tối đa 10 ảnh.';
  if (videos > 1) return 'Tối đa 1 video.';
  return validateContentFormat(format ?? null, text, images, videos);
};
